import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GameCard } from "../components/GameCard";
import { Pagination } from "../components/Pagination";
import { useSetTrail } from "../context/BreadcrumbContext";
import { api } from "../lib/api";
import type { GameSummary } from "../types/domain";

const PAGE_SIZE = 10;

function GameCardSkeleton() {
  return (
    <div className="card animate-pulse">
      <div className="flex items-center justify-between gap-4">
        <div className="h-5 w-48 rounded bg-gray-200" />
        <div className="h-8 w-20 rounded bg-gray-200" />
      </div>
      <div className="mt-2 flex items-center justify-between">
        <div className="h-3 w-36 rounded bg-gray-100" />
        <div className="h-5 w-24 rounded-full bg-gray-100" />
      </div>
    </div>
  );
}

export function GamesPage() {
  const [games, setGames] = useState<GameSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useSetTrail([]);

  useEffect(() => {
    void api.listGames().then((data) => {
      setGames(data);
      setLoading(false);
    });
  }, []);

  const totalPages = Math.max(1, Math.ceil(games.length / PAGE_SIZE));
  const safeP = Math.min(page, totalPages);
  const visible = games.slice((safeP - 1) * PAGE_SIZE, safeP * PAGE_SIZE);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-ink">Parties</h1>
        <Link to="/games/new" className="btn-primary">
          + Nouvelle partie
        </Link>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <GameCardSkeleton key={i} />
          ))}
        </div>
      ) : visible.length > 0 ? (
        <div className="space-y-3">
          {visible.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      ) : (
        <p className="text-sm text-smoke">Aucune partie.</p>
      )}

      {totalPages > 1 && (
        <Pagination
          page={safeP}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
}
